import Seo from "@components/common/Seo";
import SmallBanner from "@components/common/SmallBanner";
import Text from "@components/common/Text";
import Title from "@components/common/Title";
import Layout from "@components/layouts/Layout";
import Products from "@components/sections/Products";
import ProductsNew from "@components/sections/products2/Products";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import useSWR from "swr";

// import { navigate } from "gatsby";
// import ProductList from "@base/data/Products";

const endpoints = {
    products: "/.netlify/functions/products",
};

const Tienda = () => {
    const {
        data: result,
        isValidating,
        isLoading,
    } = useSWR(endpoints.products, axios.get, {
        dedupingInterval: 30 * 1000,
    });
    const [productsState, setProductsState] = useState([]);
    useEffect(() => {
        if (result?.data?.products) {
            let products = result?.data?.products.filter(
                (x) =>
                    x.enabled &&
                    !x.hidden &&
                    x.type === "course" &&
                    x.subtype === "classroom",
                // x.category?.includes("face-to-face")
            );

            products = products.map((p) => {
                const { created_at, updated_at, ...rest } = p;
                return {
                    ...rest,
                    created_at: dayjs(created_at).toDate(),
                    updated_at: dayjs(updated_at).toDate(),
                };
            });

            products = products.sort(
                (a, b) => b.stock - a.stock || b.created_at - a.created_at,
            );

            setProductsState(products);
        }
    }, [result]);

    return (
        <>
            <Layout>
                <Seo
                    title="Nuestra tienda: Cursos presenciales"
                    description="Te ofrecemos un amplia gama de productos que seguro van
                    a adaptarse a tus necesidades: aplicaciones, libros y
                    cursos de formación, tanto online como presenciales."
                />
                <SmallBanner
                    title="Cursos presenciales"
                    subtitle="Conviértete en el opositor más fuerte"
                    filename="bgs/bgClassroom"
                />

                <div className="container py-20 lg:px-0">
                    <Title>Cursos disponibles</Title>
                    <Text className="text-justify">
                        Te ofrecemos un amplia gama de productos que seguro van
                        a adaptarse a tus necesidades: aplicaciones, libros y
                        cursos de formación, tanto online como presenciales.
                    </Text>

                    <div className="mt-10 space-y-10">
                        {process.env.GATSBY_NEW_PRODUCTS_ENABLED === "true" ? (
                            <ProductsNew
                                items={productsState}
                                loading={isLoading || isValidating}
                            />
                        ) : (
                            <Products items={productsState} />
                        )}

                        <div className="mt-10 text-right font-montserrat text-xs italic text-gray-500">
                            * I.V.A. incluido en todos los precios
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default Tienda;
